import React from 'react';

function HowToPlay({ onClose }) {
  return (
    <div className="help-overlay" onClick={onClose}>
      <div className="help-modal" onClick={(e) => e.stopPropagation()}>
        <button className="help-modal__close" onClick={onClose}>✕</button>
        <h2 className="help-modal__title">How to Play</h2>

        <div className="help-modal__section">
          <h3>Goal</h3>
          <p>Get the <strong>lowest score</strong> over 9 rounds. Just like real golf!</p>
        </div>

        <div className="help-modal__section">
          <h3>Setup</h3>
          <p>Each player gets 6 cards face-down in a 2x3 grid. Pick 2 to flip over. The rest stay hidden.</p>
        </div>

        <div className="help-modal__section">
          <h3>Your Turn</h3>
          <p><strong>1. Draw</strong> from the stock pile (unknown) or discard pile (visible).</p>
          <p><strong>2. Decide:</strong> Swap it with any card in your grid, or discard it. Swapped cards are revealed.</p>
        </div>

        <div className="help-modal__section">
          <h3>Going Out</h3>
          <p>When all 6 of your cards are face-up, every other player gets <strong>one final turn</strong>. Then scores are tallied.</p>
        </div>

        <div className="help-modal__section">
          <h3>Scoring</h3>
          <table className="help-modal__table">
            <tbody>
              <tr><td>Ace</td><td>1 point</td></tr>
              <tr><td>2</td><td>-2 points</td></tr>
              <tr><td>3-10</td><td>Face value</td></tr>
              <tr><td>J, Q</td><td>10 points</td></tr>
              <tr><td>K</td><td>0 points</td></tr>
            </tbody>
          </table>
        </div>

        <div className="help-modal__section">
          <h3>Column Bonus</h3>
          <p>If two cards in the same column match rank, that column scores <strong>0 points</strong> — even if they're high cards!</p>
          <div className="help-modal__grid-example">
            <span>[ 7 ]</span><span>[ K ]</span><span>[ 5 ]</span>
            <span>[ 7 ]</span><span>[ 3 ]</span><span>[ A ]</span>
          </div>
          <p className="help-modal__example-note">Column 1 matches (two 7s) = 0 pts. Total: 0 + 3 + 6 = 9</p>
        </div>

        <div className="help-modal__section">
          <h3>Winning</h3>
          <p>After 9 rounds, the player with the <strong>lowest total score</strong> wins.</p>
        </div>
      </div>
    </div>
  );
}

export default HowToPlay;
